import type { ReactElement } from "react";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

interface IProps {
    hasAddButton: boolean;
}

const ChipItemGroupLoading = ({ hasAddButton }: IProps): ReactElement => {
    return (
        <>
            <PixelPlaceholderLoader
                width={148}
                height={32}
            />
            <PixelPlaceholderLoader
                width={188}
                height={32}
            />
            <PixelPlaceholderLoader
                width={158}
                height={32}
            />
            <PixelPlaceholderLoader
                width={188}
                height={32}
            />
            {hasAddButton ? (
                <PixelPlaceholderLoader
                    width={32}
                    height={32}
                />
            ) : null}
        </>
    );
};

export default ChipItemGroupLoading;
